import { isArray, isUndefined } from '@dimjs/lang';
import { TPlainObject } from '@flatbiz/utils';
import { CSSProperties } from 'react';
import { CommonPropsWithChildren, withNativeProps } from '../utils/native-props';
import { px2rem } from '../utils/pxrem';
import './style.less';

export type GridProps = {
  columns: number;
  columnHeight?: number;
  gap?: number | [number, number];
} & CommonPropsWithChildren;

/**
 *  网格布局
 * ```
 * 1. columns 水平方向上网格格数
 * 2. columnHeight 单个网格高度，视觉稿高度，数值将被转换成rem
 * 3. gap 网格间隙，默认值：30
 *    a. number：上下左右相同
 *    b. [number, number]: [上下，左右]
 * ```
 */
export const Grid = (props: GridProps) => {
  const gap = isUndefined(props.gap) ? 30 : props.gap;
  const gapArray = (isArray(gap) ? gap : [gap]) as number[];
  const style: CSSProperties & TPlainObject<string> = {
    '--grid-template-columns': `repeat(${props.columns}, 1fr)`,
    gap: `${px2rem(gapArray[0])} ${px2rem(gapArray[1] || gapArray[0])}`,
  };

  if (props.columnHeight) {
    style.gridAutoRows = px2rem(props.columnHeight);
  }

  return withNativeProps(
    props,
    <div className="v-grid" style={style}>
      {props.children}
    </div>,
  );
};
